<div class="footer">
    <div class="footer-content">
        <div class="footer-spacer"></div>
        <div class="footer-main-group">
            <div class="navigation-section">
                @if (enablePreviousButton) {
                <button mat-raised-button
                        class="tbp"
                        (click)="invokePrevious()"
                        [disabled]="isFirstQuestion || isSaving">
                    <mat-icon>arrow_back</mat-icon>&nbsp;{{previousButtonLabel}}
                </button>
                }
            </div>

            <div class="tools-section">
                @if (isMathsExam) {
                <mat-button-toggle-group [(ngModel)]="selectedActions" [multiple]="true">
                    <mat-button-toggle class="tbp" (click)="toggleTool(ExamToolIdentifier.Protractor)" value="ruler"><mat-icon svgIcon="Protractor" matTooltip="Protractor" matTooltipPosition="right"></mat-icon></mat-button-toggle>
                    <mat-button-toggle class="tbp" (click)="toggleTool(ExamToolIdentifier.Ruler)" value="protractor"><mat-icon svgIcon="Ruler" matTooltip="Ruler" matTooltipPosition="right"></mat-icon></mat-button-toggle>
                    @if (enableFlagBtn) {
                    <mat-button-toggle class="tbp" (click)="flagCurrentQuestion()" [checked]="questionIsFlagged()"><mat-icon>flag</mat-icon>&nbsp;Flag</mat-button-toggle>
                    }
                </mat-button-toggle-group>
                }
                @if (!isMathsExam && isExam) {
                <mat-button-toggle-group [(ngModel)]="selectedActions" [multiple]="true">
                    @if (enableFlagBtn) {
                    <mat-button-toggle class="tbp" (click)="flagCurrentQuestion()" [checked]="questionIsFlagged()"><mat-icon>flag</mat-icon>&nbsp;Flag</mat-button-toggle>
                    }
                </mat-button-toggle-group>
                }
                @if (isTutorial) {
                <mat-button-toggle-group [(ngModel)]="selectedActions" [multiple]="true">
                    @if (showMathsTools()) {
                    <mat-button-toggle class="tbp" (click)="toggleTool(ExamToolIdentifier.Protractor)" value="ruler"><mat-icon svgIcon="Protractor" matTooltip="Protractor" matTooltipPosition="right"></mat-icon></mat-button-toggle>
                    <mat-button-toggle class="tbp" (click)="toggleTool(ExamToolIdentifier.Ruler)" value="protractor"><mat-icon svgIcon="Ruler" matTooltip="Ruler" matTooltipPosition="right"></mat-icon></mat-button-toggle>
                    }
                </mat-button-toggle-group>
                }
            </div>

            <div class="navigation-section">
                @if (enableNextButton) {
                <button mat-raised-button
                        class="tbp"
                        (click)="isLastQuestion ? invokeEnd() : invokeNext()"
                        [disabled]="isSaving">
                    {{nextButtonLabel}}&nbsp;
                    <mat-icon>arrow_forward</mat-icon>
                </button>
                }
            </div>
        </div>
        @if (showProtractorSlider) {
        <div class="protractor-slider">
            <span>Resize Protractor</span>
            <mat-slider discrete min="0.5" max="1.5" step="0.01">
                <input matSliderThumb (ngModelChange)="updateProtractorSizeRatio($event)" [(ngModel)]="sizeRatio" />
            </mat-slider>
        </div>
        }
        <div class="footer-spacer"></div>
    </div>
</div>
